import SkeletonText from 'automation-ui-core/components/SkeletonText';
import { ENROLLED_OBJECT } from 'automation-ui-formula-editor/data-sources/constants/dataSourcesConstants';
import { useGetDataProperties } from 'automation-ui-formula-editor/data-sources/hooks/useGetDataProperties';
import getTokenParts from 'automation-ui-formula-editor/data-sources/utils/getTokenParts';
import { isLegacyTokenPrefix } from 'automation-ui-formula-editor/data-sources/utils/isLegacyTokenPrefix';
import FormulaEditorToken from 'automation-ui-formula-editor/formula-editor/FormulaEditorToken';
import FieldSources from 'automation-ui-formula-editor/formula-editor/grammar/constants/FieldSources';
import { useMemo } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledFormulaViewer = styled.span.withConfig({
  displayName: "FormulaViewer__StyledFormulaViewer",
  componentId: "sc-1v63ira-0"
})(({
  theme: _theme
}) => {
  const theme = _theme;
  return Object.assign({}, theme.typography['code-100']);
});
const FormulaViewer = ({
  actionOutputs,
  formulaState,
  propertiesByGroup
}) => {
  const fields = useMemo(() => {
    const fieldExpressions = formulaState ? formulaState.getFieldExpressions() : [];
    return fieldExpressions.map(({
      name,
      source,
      location
    }) => {
      const fieldName = source === FieldSources.VARIABLE_CONTEXT ? formulaState.variableContext.get(name).propertyToken : name;
      const {
        prefix,
        property,
        tokenPath
      } = getTokenParts(fieldName);
      return {
        location,
        name,
        prefix: isLegacyTokenPrefix(prefix) ? ENROLLED_OBJECT : prefix,
        property,
        tokenPath
      };
    });
  }, [formulaState]);
  const {
    data: dataSourcesByPrefix,
    error,
    loading
  } = useGetDataProperties(fields);
  const dataSources = useMemo(() => new Map(dataSourcesByPrefix ? fields.map(({
    prefix,
    property,
    tokenPath
  }) => {
    const dataSource = dataSourcesByPrefix.get(prefix);
    return [tokenPath, dataSource && dataSource.dataSourceProperties[property]];
  }) : []), [fields, dataSourcesByPrefix]);
  if (!formulaState) {
    return /*#__PURE__*/_jsx(SkeletonText, {});
  }
  const parts = [];
  let lastIndex = 0;
  fields.forEach((field, key) => {
    const {
      start: {
        offset: start
      },
      end: {
        offset: end
      }
    } = field.location;
    parts.push(formulaState.formulaText.substring(lastIndex, start));
    lastIndex = end;
    parts.push(loading ? /*#__PURE__*/_jsx(SkeletonText, {
      width: 80
    }, key) : /*#__PURE__*/_jsx(FormulaEditorToken, {
      actionOutputs: actionOutputs,
      dataSources: dataSources,
      fieldName: field.name,
      formulaState: formulaState,
      propertiesByGroup: propertiesByGroup,
      useError: !!error
    }, key));
  });
  parts.push(formulaState.formulaText.substring(lastIndex));
  return /*#__PURE__*/_jsx(StyledFormulaViewer, {
    children: parts
  });
};
export default FormulaViewer;